import { isIOSApp, isAndroidApp, isNativeApp, isWeb } from '../utils/platform';

// Feature flags for controlling experimental features
export const FEATURES = {
  VIRTUAL_PET: process.env.REACT_APP_ENABLE_VIRTUAL_PET === 'true',
  TEST_MODE: process.env.REACT_APP_TEST_MODE === 'true',
  // Add more feature flags here
};

// iOS 앱에서 비활성화할 기능 목록
// true로 설정하면 iOS 앱에서 해당 기능이 비활성화됩니다
export const IOS_APP_DISABLED_FEATURES = {
  // 예시: iOS 앱에서 비활성화할 기능들을 여기에 추가
  // MINECRAFT_EDUCATION: true,
  // MAKE_CODE_ARCADE: true,
  // LEGO_EDUCATION: true,
  // IB_GRADING: true,
  // TOOLS: true,
  // NOTES: true,
};

// Android 앱에서 비활성화할 기능 목록
export const ANDROID_APP_DISABLED_FEATURES = {
  // Android 앱에서 비활성화할 기능들
};

// 네이티브 앱(iOS + Android)에서 비활성화할 기능 목록
export const NATIVE_APP_DISABLED_FEATURES = {
  SEATING: true,
  CLASS_MATERIALS: true,
};

const NATIVE_MENU_FEATURES: Record<string, keyof typeof NATIVE_APP_DISABLED_FEATURES> = {
  'seating-management': 'SEATING',
  'seat-reservation': 'SEATING',
  'class-materials': 'CLASS_MATERIALS',
};

/**
 * 특정 기능이 현재 플랫폼에서 사용 가능한지 확인합니다.
 * @param feature - 확인할 기능 이름 (IOS_APP_DISABLED_FEATURES의 키)
 * @returns true면 사용 가능, false면 비활성화됨
 */
export const isFeatureAvailable = (feature: keyof typeof IOS_APP_DISABLED_FEATURES | keyof typeof NATIVE_APP_DISABLED_FEATURES): boolean => {
  // 네이티브 앱 공통 비활성화 기능 확인
  if (isNativeApp() && NATIVE_APP_DISABLED_FEATURES[feature as keyof typeof NATIVE_APP_DISABLED_FEATURES]) {
    return false;
  }
  
  // iOS 앱 전용 비활성화 기능 확인
  if (isIOSApp() && IOS_APP_DISABLED_FEATURES[feature as keyof typeof IOS_APP_DISABLED_FEATURES]) {
    return false;
  }
  
  // Android 앱 전용 비활성화 기능 확인
  if (isAndroidApp() && ANDROID_APP_DISABLED_FEATURES[feature as keyof typeof ANDROID_APP_DISABLED_FEATURES]) {
    return false;
  }
  
  return true;
};

/** 네이티브 앱에서 숨길 메뉴인지 확인합니다. 웹에서는 항상 표시합니다. */
export const isNativeMenuVisible = (menuId: string): boolean => {
  const feature = NATIVE_MENU_FEATURES[menuId];
  if (!feature) return true;
  return isFeatureAvailable(feature);
};

// Helper function to check if feature is enabled
export const isFeatureEnabled = (feature: keyof typeof FEATURES): boolean => {
  return FEATURES[feature];
};
